// Single source of truth for the brand details displayed across the
// app's legal docs and contact footer. Keep this list short — the
// pages reference these by name so a rebrand only needs to touch one file.
export const LEGAL = {
  company: "Avidity Cleaning Services",
  shortName: "Avidity",
  productName: "Avidity ShiftGrid",
  contactEmail: "privacy@avidity-cleaning.com.au",
  supportPhone: "0416 032 424",
  jurisdiction: "New South Wales, Australia",
  governingLaw: "the laws of New South Wales, Australia",
  effectiveDate: "13 February 2026",
};
